import { StyleSheet } from "react-native";

const styles = StyleSheet.create({
    content: {
        paddingHorizontal: 25,
    },
    contentList: {
        marginTop: 5
    },
    iconInfo: {
        marginTop: 5
    },
    contentItemList: {
        flexDirection: 'row',
        justifyContent: 'space-between',
        marginTop: 15
    },
    titleItemList: {
        fontSize: 21,
        fontWeight: 'bold',
        marginTop: -1
    },
    descriptionItemList: {
        fontSize: 14,
        color: '#939394',
        width: '90%',
        marginTop: 10,
        marginBottom: 10
    },
    hr: {
        height: 2,
        marginTop: 10,
        backgroundColor: "#2C2C2E",
        opacity: 0.5
    }
});

export default styles;
